"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableAreaChart = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var bucket_1 = require("../../../constants/bucket");
var supportedProperties_1 = require("../../../constants/supportedProperties");
var uiConfig_1 = require("../../../constants/uiConfig");
var bucketConfig_1 = require("../../../utils/bucketConfig");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
var sort_1 = require("../../../utils/sort");
var areaChartUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/areaChartUiConfigHelper");
var LineChartBasedConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/LineChartBasedConfigurationPanel"));
var PluggableBaseChart_1 = require("../baseChart/PluggableBaseChart");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var drillDownUtil_1 = require("../drillDownUtil");
var PluggableAreaChart = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableAreaChart, _super);
    function PluggableAreaChart(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.AREA;
        _this.defaultControlsProperties = {
            stackMeasures: true,
        };
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableAreaChart.prototype.getUiConfig = function () {
        return cloneDeep_1.default(this.isMultipleDatesEnabled() ? uiConfig_1.AREA_UICONFIG_WITH_MULTIPLE_DATES : uiConfig_1.DEFAULT_AREA_UICONFIG);
    };
    PluggableAreaChart.prototype.updateInstanceProperties = function (options, insight, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    insightPropertiesMeta) {
        _super.prototype.updateInstanceProperties.call(this, options, insight, insightPropertiesMeta);
        this.updateCustomSupportedProperties(insight);
    };
    PluggableAreaChart.prototype.getExtendedReferencePoint = function (referencePoint) {
        var clonedReferencePoint = cloneDeep_1.default(referencePoint);
        var newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, clonedReferencePoint), { uiConfig: this.getUiConfig() });
        newReferencePoint = bucketHelper_1.removeAllArithmeticMeasuresFromDerived(newReferencePoint);
        newReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newReferencePoint);
        this.configureBuckets(newReferencePoint);
        newReferencePoint = areaChartUiConfigHelper_1.setAreaChartUiConfig(newReferencePoint, this.intl, this.type);
        newReferencePoint = bucketConfig_1.configurePercent(newReferencePoint, false);
        newReferencePoint = bucketConfig_1.configureOverTimeComparison(newReferencePoint, !!this.featureFlags["enableWeekFilters"]);
        this.supportedPropertiesList = propertiesHelper_1.removeImmutableOptionalStackingProperties(newReferencePoint, this.getSupportedPropertiesList());
        newReferencePoint = propertiesHelper_1.getReferencePointWithSupportedProperties(newReferencePoint, this.supportedPropertiesList);
        newReferencePoint = sort_1.removeSort(newReferencePoint);
        return Promise.resolve(bucketHelper_1.sanitizeFilters(newReferencePoint));
    };
    PluggableAreaChart.prototype.configureBuckets = function (extendedReferencePoint) {
        var _a = this.isMultipleDatesEnabled()
            ? this.getBucketItemsWithMultipleDates(extendedReferencePoint)
            : this.getBucketItems(extendedReferencePoint), measures = _a.measures, views = _a.views, stacks = _a.stacks;
        set_1.default(extendedReferencePoint, bucket_1.BUCKETS, [
            {
                localIdentifier: sdk_ui_1.BucketNames.MEASURES,
                items: measures,
            },
            {
                localIdentifier: sdk_ui_1.BucketNames.VIEW,
                items: views,
            },
            {
                localIdentifier: sdk_ui_1.BucketNames.STACK,
                items: stacks,
            },
        ]);
    };
    PluggableAreaChart.prototype.getSupportedPropertiesList = function () {
        return supportedProperties_1.AREA_CHART_SUPPORTED_PROPERTIES;
    };
    PluggableAreaChart.prototype.addFilters = function (source, drillConfig, event) {
        var cutIntersection = drillDownUtil_1.reverseAndTrimIntersection(drillConfig, event.drillContext.intersection);
        return drillDownUtil_1.addIntersectionFiltersToInsight(source, cutIntersection);
    };
    PluggableAreaChart.prototype.getInsightWithDrillDownApplied = function (source, drillDownContext) {
        var withFilters = this.addFilters(source, drillDownContext.drillDefinition, drillDownContext.event);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    PluggableAreaChart.prototype.renderConfigurationPanel = function (insight) {
        if (document.querySelector(this.configPanelElement)) {
            react_dom_1.render(react_1.default.createElement(LineChartBasedConfigurationPanel_1.default, { locale: this.locale, colors: this.colors, properties: this.visualizationProperties, propertiesMeta: this.propertiesMeta, insight: insight, references: this.references, pushData: this.handlePushData, type: this.type, isError: this.getIsError(), isLoading: this.isLoading, featureFlags: this.featureFlags }), document.querySelector(this.configPanelElement));
        }
    };
    PluggableAreaChart.prototype.updateCustomSupportedProperties = function (insight) {
        if (sdk_model_1.bucketsItems(sdk_model_1.insightBuckets(insight, sdk_ui_1.BucketNames.VIEW)).length > 1) {
            this.addSupportedProperties(supportedProperties_1.OPTIONAL_STACKING_PROPERTIES);
            this.setCustomControlsProperties({
                stackMeasures: false,
                stackMeasuresToPercent: false,
            });
        }
        else {
            this.setCustomControlsProperties({});
        }
    };
    PluggableAreaChart.prototype.addSupportedProperties = function (properties) {
        var supportedPropertiesList = this.supportedPropertiesList;
        (properties || []).forEach(function (property) {
            if (!supportedPropertiesList.some(function (supportedProperty) { return supportedProperty === property; })) {
                supportedPropertiesList.push(property);
            }
        });
    };
    PluggableAreaChart.prototype.getAllAttributes = function (buckets) {
        return bucketHelper_1.getAllAttributeItemsWithPreference(buckets, [
            sdk_ui_1.BucketNames.TREND,
            sdk_ui_1.BucketNames.VIEW,
            sdk_ui_1.BucketNames.SEGMENT,
            sdk_ui_1.BucketNames.STACK,
        ]);
    };
    PluggableAreaChart.prototype.getAllAttributesWithoutDate = function (buckets) {
        return this.getAllAttributes(buckets).filter(bucketHelper_1.isNotDateBucketItem);
    };
    PluggableAreaChart.prototype.filterStackItems = function (bucketItems) {
        return bucketItems.filter(bucketHelper_1.isNotDateBucketItem).slice(0, uiConfig_1.MAX_STACKS_COUNT);
    };
    PluggableAreaChart.prototype.getBucketItems = function (referencePoint) {
        var _a;
        var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
        var measures = bucketHelper_1.getFilteredMeasuresForStackedCharts(buckets);
        var dateItems = bucketHelper_1.getDateItems(buckets);
        var mainDateItem = bucketHelper_1.getMainDateItem(dateItems);
        var stacks = this.filterStackItems(bucketHelper_1.getStackItems(buckets));
        var isAllowMoreThanOneViewByAttribute = !stacks.length && measures.length <= 1;
        var numOfAttributes = isAllowMoreThanOneViewByAttribute ? uiConfig_1.MAX_VIEW_COUNT : 1;
        var views = bucketHelper_1.removeDivergentDateItems(bucketHelper_1.getAllCategoriesAttributeItems(buckets), mainDateItem).slice(0, numOfAttributes);
        var hasDateItemInViewByBucket = views.some(bucketHelper_1.isDateBucketItem);
        if (dateItems.length && !hasDateItemInViewByBucket) {
            var allAttributes = this.getAllAttributesWithoutDate(buckets);
            var extraViewItems = allAttributes.slice(0, numOfAttributes - 1);
            views = numOfAttributes > 1 ? tslib_1.__spreadArrays([mainDateItem], extraViewItems) : [mainDateItem];
            if (!isAllowMoreThanOneViewByAttribute && measures.length <= 1) {
                stacks = allAttributes.slice(0, uiConfig_1.MAX_STACKS_COUNT);
            }
        }
        return {
            measures: measures,
            views: views,
            stacks: stacks,
        };
    };
    PluggableAreaChart.prototype.getViewByMaxItemCount = function (referencePoint) {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = referencePoint.uiConfig) === null || _a === void 0 ? void 0 : _a.buckets) === null || _b === void 0 ? void 0 : _b[sdk_ui_1.BucketNames.VIEW]) === null || _c === void 0 ? void 0 : _c.itemsLimit) !== null && _d !== void 0 ? _d : uiConfig_1.MAX_CATEGORIES_COUNT;
    };
    PluggableAreaChart.prototype.getBucketItemsWithMultipleDates = function (referencePoint) {
        var _a;
        var buckets = (_a = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets) !== null && _a !== void 0 ? _a : [];
        var measures = bucketHelper_1.getFilteredMeasuresForStackedCharts(buckets);
        var viewByMaxItemCount = this.getViewByMaxItemCount(referencePoint);
        var stacks = bucketHelper_1.getStackItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
        var allAttributesWithoutStacks = bucketHelper_1.getAllAttributeItemsWithPreference(buckets, [
            sdk_ui_1.BucketNames.LOCATION,
            sdk_ui_1.BucketNames.TREND,
            sdk_ui_1.BucketNames.VIEW,
            sdk_ui_1.BucketNames.ATTRIBUTES,
            sdk_ui_1.BucketNames.SEGMENT,
            sdk_ui_1.BucketNames.STACK,
        ]).filter(function (attribute) { return !stacks.includes(attribute); });
        var maxViews = stacks.length || measures.length > 1 ? 1 : viewByMaxItemCount;
        var views = allAttributesWithoutStacks.slice(0, maxViews);
        return {
            measures: measures,
            views: views,
            stacks: stacks,
        };
    };
    return PluggableAreaChart;
}(PluggableBaseChart_1.PluggableBaseChart));
exports.PluggableAreaChart = PluggableAreaChart;
//# sourceMappingURL=PluggableAreaChart.js.map